import React, { useContext } from 'react'

import { LanguageContext } from '../../../context/LanguageContext'
import { hasLocalizations } from '../../../util/importPages'
import { util } from '../../../util'
import { Accordion, InputField, Typography } from '..'

const InputLocalization = ({
    className,
    fieldKey,
    languages,
    languageSection,
    localizations,
    readOnly,
    setState,
    validation,
}) => {
    //Context
    const { strings } = useContext(LanguageContext)

    //Handlers
    const inputFieldHandler = (value, language) => {
        setState(prevState => {
            //Set up new state object
            const newState = {
                ...prevState,
                localizations: {
                    ...prevState.localizations,
                    [language]: {
                        ...prevState.localizations[language],
                    },
                },
            }

            //Delete attribute when empty, otherwise add value
            if (!value.length) {
                delete newState.localizations[language][fieldKey]
            } else {
                if (!validation || validation(value))
                    newState.localizations[language][fieldKey] = value
            }

            //Delete language attribute if empty
            if (!Object.keys(newState.localizations[language]).length) {
                delete newState.localizations[language]
            }

            //Return new state
            return newState
        })
    }

    //Render
    return (
        <Accordion forceClose={false} className={util.joinClasses('input-localization', className)}>
            <Accordion.Summary showPadding defaultLayout>
                <Typography
                    text={strings.LOCALIZATIONS}
                    size={'sm'}
                    fontType={'medium'}
                    variant={'p'}
                />
            </Accordion.Summary>
            <Accordion.Details>
                <React.Fragment>
                    {languages && hasLocalizations(localizations, fieldKey).length ? (
                        languages.map((language, index) => {
                            const localizedField = localizations?.[language]?.[fieldKey]

                            const value =
                                !localizedField && readOnly
                                    ? strings.LOCALIZATIONS_NOT_FOUND
                                    : localizedField || ''

                            const onChange = e => {
                                const { value: val } = e.target
                                return inputFieldHandler(val, language)
                            }
                            const label = language.toUpperCase()

                            if (languageSection)
                                return languageSection({ index, label, onChange, readOnly, value })
                            return (
                                <div key={index} className={'py-2'}>
                                    <InputField
                                        className={'input-localization__field'}
                                        isFullWidth
                                        label={label}
                                        onChange={onChange}
                                        readOnly={readOnly}
                                        type={'text'}
                                        value={value}
                                    />
                                </div>
                            )
                        })
                    ) : (
                        <Typography text={strings.LOCALIZATIONS_NOT_FOUND} className={'py-2'} />
                    )}
                </React.Fragment>
            </Accordion.Details>
        </Accordion>
    )
}

export default InputLocalization
